function formatSinceTime(isoString: string): string {
  return new Date(isoString).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

interface NewMessagesPillProps {
  count: number;
  sinceTime: string | null;
  onClick: () => void;
}

export function NewMessagesPill({ count, sinceTime, onClick }: NewMessagesPillProps): React.JSX.Element | null {
  if (count === 0) return null;

  return (
    <button
      onClick={onClick}
      className="sticky top-0 z-30 -mx-3 -mt-3 mb-1 w-[calc(100%+1.5rem)] flex items-center justify-between px-3 py-1.5 bg-accent-yellow hover:bg-wheat text-hot-tag-text text-xs font-medium transition-colors cursor-pointer"
    >
      <span>
        {count} new message{count !== 1 ? 's' : ''}
        {sinceTime && <> since {formatSinceTime(sinceTime)}</>}
      </span>
      <span className="flex items-center gap-1.5">
        Mark As Read
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
        </svg>
      </span>
    </button>
  );
}
